import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { EstruturaRetornoDadosOutputDto } from 'src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto';
import { ObterUltimaEdicaoECalendarioOutputDto } from 'src/app/domain/DTOs/output/jornal/ultima-edicao-e-calendario-para-home-output.dto';
import { ListarEdicoesParaCalendarioInputDto } from 'src/app/domain/DTOs/input/jornal/listar-edicoes-para-calendario-input.dto';
import { ListarEdicoesParaCalendarioOutputDto } from 'src/app/domain/DTOs/output/jornal/listar-edicoes-para-calendario-output.dto';
import { EdicaoOutputDto } from 'src/app/domain/DTOs/output/jornal/edicao-output.dto';
@Injectable()
export class JornalService {

  constructor(private baseService: BaseService) {}

  public ObterUltimaEdicaoECalendario(
  ): Observable<EstruturaRetornoDadosOutputDto<ObterUltimaEdicaoECalendarioOutputDto>> {
    return this.baseService.get('Jornal/ObterUltimaEdicaoECalendarioParaHome');
  }

  public ObterUltimaEdicao(
  ): Observable<EstruturaRetornoDadosOutputDto<EdicaoOutputDto>> {
    return this.baseService.get('Jornal/ObterUltimaEdicao');
  }

  public ListarEdicoesParaCalendario(
    inputDto: ListarEdicoesParaCalendarioInputDto
  ): Observable<EstruturaRetornoDadosOutputDto<ListarEdicoesParaCalendarioOutputDto[]>> {
    return this.baseService.get(`Jornal/ListarEdicoesParaCalendario?MesPublicacao=${inputDto.mesPublicacao}&AnoPublicacao=${inputDto.anoPublicacao}`);
  }

  public ObterEdicaoPorDataPublicacao(
    inputDto: string
  ): Observable<EstruturaRetornoDadosOutputDto<EdicaoOutputDto>> {
    return this.baseService.get(`Jornal/ObterEdicaoPorDataPublicacao?dataPublicacao=${inputDto}`);
  }

  public ObterEdicaoPorId(
    inputDto: number, pagina?: number
  ): Observable<EstruturaRetornoDadosOutputDto<EdicaoOutputDto>> {
    if(pagina)
      return this.baseService.get(`Jornal/ObterEdicaoPorId/${inputDto}?pagina=${pagina}`);
    
    return this.baseService.get(`Jornal/ObterEdicaoPorId/${inputDto}`);
  }
}